var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== null
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _vm.fieldId === "10112900"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.screening.screeningSmoking)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldId === "10112959"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.screening.screeningHypertension
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldId === "10112960"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.screening.screeningDiabetesTypeOne
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldId === "10112961"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.screening.screeningDiabetesTypeTwo
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldId === "10113022"
                ? _c("div", { staticClass: "col-md-8" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.screening.screeningArteriosclerosis
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldId === "10113032"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.screening.screeningStroke)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldId === "10113155"
                ? _c("div", { staticClass: "col-md-8" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.screening.screeningPeephole)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fieldId === "10113375"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("p", {
                      ref: "scrQuestion",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.welcomepage.consentShareJournals
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: ["10113155", "10113022"].includes(_vm.fieldId)
                    ? "col-md-8"
                    : "col-md-6"
                },
                [
                  ["10113022", "10113032", "10113155"].includes(_vm.fieldId) &&
                  _vm.yes_age &&
                  _vm.age !== 0 &&
                  !_vm.yes_share
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success btn-lg btn-block",
                          on: {
                            click: function($event) {
                              return _vm.verifyAnswer("Ja")
                            }
                          }
                        },
                        [_vm._v("\n          Nästa\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  ["10113022", "10113032", "10113155"].includes(_vm.fieldId) &&
                  _vm.yes_age
                    ? _c("label", { staticClass: "pull-left text-left" }, [
                        _vm._v(
                          "\n          Vid vilken ålder drabbades du/fick det bekräftat första gången?\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  ["10113022", "10113032", "10113155"].includes(_vm.fieldId) &&
                  _vm.yes_age
                    ? _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.age,
                              expression: "age"
                            }
                          ],
                          staticClass: "form-control m-w-220",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.age = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: 0 } }, [
                            _vm._v("Välj ålder")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.ages0to100, function(age) {
                            return _c(
                              "option",
                              { key: age, domProps: { value: age } },
                              [_vm._v(_vm._s(age))]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm.fieldId === "10113375"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          class:
                            _vm.previousanswer === "Ja" || _vm.yes_share
                              ? "previous-answer"
                              : "",
                          on: {
                            click: function($event) {
                              _vm.yes_share = true
                            }
                          }
                        },
                        [_vm._v("Ja")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ["10113022", "10113032", "10113155"].includes(_vm.fieldId)
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          class:
                            _vm.previousanswer === "Ja" || _vm.yes_age
                              ? "previous-answer"
                              : "",
                          on: {
                            click: function($event) {
                              _vm.yes_age = true
                            }
                          }
                        },
                        [_vm._v("Ja")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !["10113022", "10113032", "10113155", "10113375"].includes(
                    _vm.fieldId
                  )
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          class:
                            _vm.previousanswer === "Ja"
                              ? "previous-answer"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.verifyAnswer("Ja")
                            }
                          }
                        },
                        [_vm._v("Ja")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm.fieldId === "10112900"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          class:
                            _vm.previousanswer === "Nej (slutat röka)" &&
                            !_vm.yes_age
                              ? "previous-answer"
                              : "",
                          on: {
                            click: function($event) {
                              _vm.verifyAnswer("Nej (slutat röka)")
                            }
                          }
                        },
                        [_vm._v("Nej (slutat röka)")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  ["10113022", "10113032", "10113155"].includes(_vm.fieldId)
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          class:
                            _vm.previousanswer === "Nej" && !_vm.yes_age
                              ? "previous-answer"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.confirmAnswer()
                            }
                          }
                        },
                        [_vm._v("Nej")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !["10113022", "10113032", "10113155"].includes(_vm.fieldId)
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          class:
                            _vm.previousanswer === "Nej"
                              ? "previous-answer"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.verifyAnswer("Nej")
                            }
                          }
                        },
                        [_vm._v("Nej")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm.fieldId === "10113375" && _vm.yes_share
                    ? _c("div", [
                        _c(
                          "label",
                          {
                            staticClass: "pull-left text-left",
                            attrs: { for: "careFacility" }
                          },
                          [
                            _vm._v(
                              "\n            Du kan ange vårdinrättning (ex. sjukhus eller vårdcentral) där du tidigare mätt dina blodfettvärden.\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group mb-3" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.careFacility,
                                expression: "careFacility"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", id: "careFacility" },
                            domProps: { value: _vm.careFacility },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.careFacility = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm.yes_share
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success btn-lg btn-block",
                          on: {
                            click: function($event) {
                              return _vm.verifyAnswer("Ja")
                            }
                          }
                        },
                        [_vm._v("Nästa")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark btn-lg btn-block",
                      on: {
                        click: function($event) {
                          return _vm.goBack()
                        }
                      }
                    },
                    [_vm._v("← Tillbaka")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("small", { staticClass: "pull-left" }, [
                    _vm._v("Välj ett alternativ för att gå vidare.")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        { staticClass: "input-group-text", attrs: { id: "basic-addon3" } },
        [_vm._v("(Valfritt)")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3752fcf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3752fcf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Screening.vue
// module id = null
// module chunks = 